export const APPEARANCES = {
  light: 'light',
  dark: 'dark',
  accent: 'accent',
  lightAccent: 'light-accent',
};

export const SIZES = {
  extraLarge: 'extra-large',
  large: 'large',
  medium: 'medium',
  small: 'small',
};
